import { render, staticRenderFns } from "./PerfilMedallas.vue?vue&type=template&id=f60e95c2&scoped=true"
import script from "./PerfilMedallas.vue?vue&type=script&lang=js"
export * from "./PerfilMedallas.vue?vue&type=script&lang=js"
import style0 from "./PerfilMedallas.vue?vue&type=style&index=0&id=f60e95c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60e95c2",
  null
  
)

export default component.exports